'use client'
import { Block_Form } from '@/src/generated/graphql'
import styles from './FormBlock.module.scss'
import { useRef, useState } from 'react'
import PageGutter from '@/src/components/common/PageGutter'
import ViewForm from '@/src/components/blocks/ContentBlock/FormBlock/FormBlock.ViewForm.client'
import ViewSuccess from '@/src/components/blocks/ContentBlock/FormBlock/FormBlock.ViewSuccess.client'

export default function FormBlockClient(_: Block_Form) {
  const [view, setView] = useState<'form' | 'success'>('form')
  const ref = useRef<HTMLDivElement>(null)

  const changeView = (_view: typeof view) => {
    if (ref.current) ref.current.scrollIntoView()
    setView(_view)
  }

  return (
    <div ref={ref} className={styles.container}>
      <PageGutter>
        <div className={styles.contentWrapper}>
          {view === 'form' && (
            <ViewForm
              {..._}
              afterSubmitted={({ success }: { success: boolean }) => {
                if (success) changeView('success')
              }}
            />
          )}

          {view === 'success' && <ViewSuccess {..._} onBack={() => changeView('form')} />}
        </div>
      </PageGutter>
    </div>
  )
}
